// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__rzA_V","fixedHeight":"styles_fixedHeight__HNqcJ"};